export class billingOrganisation {
  organisationName: string = "";
  createDate: Date = new Date();
  vatReg: string = '';
  vatExemptionVerified: boolean = false;
  companyReg: string = '';
  region: string = '';
  currencyCode: string = '';
  notes: string = '';
  qbAccountCode: string = '';
  delete: boolean = false;
  billingAddress: complexAddress = new complexAddress();
  administrativeAddress: complexAddress = new complexAddress();
  billingContact: complexContact = new complexContact();
  administrativeContact: complexContact = new complexContact();
  safeId: string;
  id: string;

  users: orgUserModel[] = [];
}

export class orgUserModel {
  id: number;
  userId: string;
  userName: string;
  email: string;
}

export class complexAddress {
  id: number = 0;
  address1: string = "";
  address2: string = "";
  town: string = "";
  county: string = "";
  country: string = "UK";
  postCode: string = "";

  static compare(a: complexAddress, b: complexAddress): boolean {
    var result = true;
    if (b.address1 !== a.address1) { result = false; }
    if (b.address2 !== a.address2) { result = false; }
    if (b.town !== a.town) { result = false; }
    if (b.county !== a.county) { result = false; }
    if (b.country !== a.country) { result = false; }
    if (b.postCode !== a.postCode) { result = false; }

    return result;
  }
}

export class complexContact {
  id: number = 0;
  company: string = "";
  firstName: string = "";
  lastName: string = "";
  email: string = "";
  phone: string = "";
  fax: string = "";
  fullName: string = "";

  static compare(c: complexContact, b: complexContact): boolean {
    var result = true;
    if (b.company !== c.company) { result = false; }
    if (b.email !== c.email) { result = false; }
    if (b.fax !== c.fax) { result = false; }
    if (b.firstName !== c.firstName) { result = false; }
    if (b.lastName !== c.lastName) { result = false; }
    if (b.fullName !== c.fullName) { result = false; }
    if (b.phone !== c.phone) { result = false; }

    return result;
  }
}

export class invoice {
  id: number;
  billingOrganisationId: number;
  subscriptionId: number;
  invoiceDate: Date;
  clientRef: string;
  description: string;
  notes: string;
  subTotal: number;
  vat: number;
  total: number;
  paid: boolean;
  paidDate: Date;

  invoiceItems: invoiceItem[] = [];

}

export class invoiceItem {
  invoiceId: number;
  item: number;
  description: string;
  quantity: number;
  unitPrice: number;
  taxRate: number;
  itemTotal: number;
  taxTotal: number;
}

export class paymentMethod {
  id: number;
  billingOrganisationId: number;
  paymentProvider: string;
  providerCustomerId: string;
  providerToken: string;
  falRequestId: string;
  providerRequestUrl: string;
  paymentMethodState: string;
  extendedObjectdata: string;
  createdOn: Date;
  completedOn: Date;
  lastTransaction: Date;
  metaData: string;
  methodName: string;
  providerRequestId: string;
  expiryDate: Date;
}

export class transaction {
  id: number;
  paymentMethodId: number;
  providerTransactionRef: string;
  transactionDate: Date;
  invoiceNumber: number;
  amount: number;
  result: string;
  extendedRequestData: string;
  extendedResponseData: string;
  invocationSource: string;
}
